import { IconProps } from '../constants'
import SVGContainer from './svg-container'

const CollapseList = (props: IconProps) => (
  <SVGContainer {...props}>
    <path d='M11 10H3M11 6H3M11 14H3M11 18H3M15 20L18 17L21 20M15 4L18 7L21 4' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
  </SVGContainer>
)

export default CollapseList
